<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("tickettemplates") }}</div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div v-if="TemplateList.length > 0" class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div style="width: 100%;" >
      <table style="width: 100%;" class="list-view-table">
        <thead>
          <tr>
            <th class="text-left" style="width: 120px">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th>
              <img
                v-if="this.columnName != 't_name'"
                @click="onSortValue('t_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('t_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('t_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("tickettemplates") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(tickettemp, tickettempIndex) in TemplateList"
            :key="tickettempIndex"
          >
            <!-- <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    tickettemp.t_is_active === 'Y'
                      ? 'active'
                      : tickettemp.t_is_active === 'N' && 'inactive'
                  "
                />
                <b-dropdown variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-on:click="onTicketTemp('View', tickettemp.t_id)"
                  >
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    tickettemp.t_is_active === 'Y' ? 'active' : 'inactive'
                  "
                />
                <div
                  class="ml-4 clickable-icon"
                  @click="onTicketTemp('View', tickettemp.t_id)"
                    @mouseover="onHoverIcon(tickettemp.t_id, $event)"
                    @mouseleave="onHoverLeave"

                  style="cursor: pointer"
                  v-b-tooltip="'View'"
                  tabindex="0"
                >
                  <i class="icon-eye icon blue-icon"></i>
                </div>
              
              </div>
            </td>
            <td>{{ tickettemp.t_name }}</td>
          </tr>
        </tbody>
        <div
      v-if="hoveredHTML"
     class="floating-tooltip"
      :style="{ top: tooltipPosition.top + 'px', left: tooltipPosition.left + 'px' }"
    >
      <div v-html="hoveredHTML"></div>
    </div>
      </table>
      <b-pagination
        v-if="TemplateList.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
 
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      TemplateList: [],
      hoveredHTML: null,
      tooltipPosition: { top: 0, left: 0 }, 
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  beforeMount() {
    this.cinema_manager_add_edit_disabled =
      this.secureStore.get("USINFO").role_id;
    this.getTicketTemplateList();
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getTicketTemplateList();
      } else {
        this.currentPage = event;
        this.getTicketTemplateList();
      }
    },

    onTicketTemp: function (type, id) {
      this.$router.push({
        path: "/master/view-ticket-templates",
        query: { t_id: id },
      });
    },

    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getTicketTemplateList();
    },
    // onHoverIcon(templateId) {
    //   let body = {
    //     temp_id: templateId,
    //     flag: "View"
    //   };

    //   MasterService.GetTicketTemplate(body).then(response => {
    //     console.log("response :", response);
    //     this.hoveredHTML = response.data;
    //   });
    // },
    onHoverIcon(templateId, event) {
  // Fetch the HTML content
  let body = {
    temp_id: templateId,
    flag: "View"
  };

  MasterService.GetTicketTemplate(body).then(response => {
    if (response.data) {
      this.hoveredHTML = response.data;

      // Position the tooltip near the hovered icon
      const iconRect = event.target.getBoundingClientRect();
      const tooltipWidth = 300; // Adjust based on tooltip's width
      const offset = -10;
      const leftOffset=-50 // Spacing between icon and tooltip
      console.log("Hovered HTML Content:", this.hoveredHTML);
      this.tooltipPosition = {
        top: iconRect.top + window.scrollY - offset, // Above the icon
        left: Math.min(
          iconRect.left + window.scrollX,
          window.innerWidth - tooltipWidth - leftOffset
        ), // Prevent overflow
      };
    }
  });
},
// onHoverIcon(templateId, event) {
//   // Fetch the HTML content for the tooltip
//   let body = {
//     temp_id: templateId,
//     flag: "View",
//   };

//   MasterService.GetTicketTemplate(body).then((response) => {
//     if (response.data) {
//       this.hoveredHTML = response.data;

//       // Get the icon's position
//       const iconRect = event.target.getBoundingClientRect();
//       const tooltipWidth = 300; // Adjust as needed
//       const tooltipHeight = 200; // Adjust based on content size
//       const offset = 10; // Spacing between icon and tooltip

//       // Calculate the tooltip's position
//       this.tooltipPosition = {
//         top: iconRect.top + window.scrollY - tooltipHeight - offset, // Place above the icon
//         left: Math.min(
//           iconRect.left + window.scrollX,
//           window.innerWidth - tooltipWidth - offset
//         ), // Prevent overflow to the right
//       };
//     }
//   });
// },


    onHoverLeave() {
      this.hoveredHTML = null; // Hide the tooltip when the mouse leaves
    },

    getTicketTemplateList: function () {
      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
      };
      console.log("body :", body);
      MasterService.GetTicketTemplate(body).then((response) => {
        // console.log("response :", response);
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.TemplateList = data.Records;

            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          }
        }
      });
    },
  },
};
</script>
<style scoped>
/* .floating-tooltip {
  position: absolute;
  width: auto;
  height: auto;
  max-height:700px;
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  z-index: 1000; 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  overflow: hidden; 
  pointer-events: none; 
  transform: scale(0.4);
  transform-origin: top left; 
} */
.floating-tooltip {
  position: fixed;
    width: auto;
  height: auto;
   max-height: 700px; 
  /* max-width: 300px;   */
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  z-index: 1000; 
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); */
  border-radius: 4px;
  /* overflow: hidden;  */
  overflow-y: auto;
  /* overflow-x: auto; */

  pointer-events: none; 
  /* transform: scale(0.4);  */
  transform-origin: top left;
}



/* Optional: Prevent the table from shrinking when the tooltip is shown */
.list-view-table {
  table-layout: fixed;
  width: 100%;
}



</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/TicketTemplates/ticketTemplates.vue